import React, { useState } from 'react'
import { Box, InputLabel, Stack, TextField } from '@mui/material'
import { grey } from '../../../../colors'
import { NonUniversityDomain } from '../../../../models/DataObject'
import GenericButton from '../../../../components/GenericButton'
import { DomainWarningSnackbar } from './DomainWarningSnackbar'
import { ButtonType, ButtonSize } from '../../../../components/GenericButton/styles'

interface EmailInputFormProps {
  email: string
  setEmail: (email: string) => void
  isPending: boolean
  onSubmit: () => void
  setManualLogin: () => void
  openSnackbar: boolean
  setOpenSnackbar: (open: boolean) => void
}

export const EmailInputForm: React.FC<EmailInputFormProps> = ({ email, setEmail, isPending, onSubmit, setManualLogin, openSnackbar, setOpenSnackbar }) => {
  const isNonUniversityDomain = (domain: string | undefined): boolean => {
    if (!domain) return false
    const nonUniversityDomains = Object.values(NonUniversityDomain)
    return nonUniversityDomains.includes(domain as NonUniversityDomain)
  }

  const handleEmailChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    setEmail(e.target.value)
    const domain = e.target.value.split('@')[1]?.toLowerCase()
    setOpenSnackbar(isNonUniversityDomain(domain))
  }

  return (
    <>
      <form
        onSubmit={e => {
          e.preventDefault()
          onSubmit()
        }}
      >
        <Stack spacing={2.5} textAlign='left'>
          <Box>
            <InputLabel
              htmlFor='institution-email'
              sx={{
                mb: 1,
                textAlign: 'left',
                fontSize: '0.875rem',
                fontWeight: 500,
                color: grey[900]
              }}
            >
              Institution email
            </InputLabel>
            <TextField
              id='institution-email'
              required={true}
              value={email}
              onChange={handleEmailChange}
              placeholder='name@university.edu'
              fullWidth
              autoFocus
              type='email'
              autoComplete='email'
            />
          </Box>
          <GenericButton
            label='Continue'
            buttonType={ButtonType.Primary}
            loading={isPending}
            disabled={isPending}
            type='submit'
            sx={{ fontSize: '14px', fontWeight: 600 }}
          />
          <GenericButton
            label='Try Manual Login'
            variant='text'
            buttonType={ButtonType.Ghost}
            buttonSize={ButtonSize.Medium}
            fontWeight='500'
            disabled={isPending}
            type='button'
            onClick={() => { setManualLogin() }}
            sx={{
              alignSelf: 'center',
              px: 0.5,
              minWidth: 0,
              justifyContent: 'center'
            }}
          />
        </Stack>
      </form>
      <DomainWarningSnackbar open={openSnackbar} onClose={() => { setOpenSnackbar(false) }} />
    </>
  )
}
